import {
  CenterTeachingHallCost,
  CenterTeachingHallCostInput
} from '../../../lib/types/models/center/center-teaching-hall-costs'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function updateCenterTeachingHallCosts(id: number, data: CenterTeachingHallCostInput[]) {
  return restApiClient
    .url(constructApiUrl(API.centers.updateCenterTeachingHallCosts.url, { id }))
    .patch<CenterTeachingHallCost[], CenterTeachingHallCostInput[]>(data)
}
